import { PerformerRequest } from '@silbo/core';

export const getRequestType = (request: PerformerRequest) => {
  if (request.request.requestType === 'BED_MUTATION') {
    return;
  }

  if (
    request.request.originAccommodation?.unit?.type === 'EMERGENCY' ||
    request.request.originAccommodation?.unit?.isEmergency
  ) {
    return 'EMERGENCY';
  }

  return request.request.requestType as 'INTERNAL_MUTATION' | 'DIRECT_ADMISSION';
};
